// Contact footer — a single clickable line at the bottom of the
// page. Clicking the link both fires the mailto (native behavior,
// opens the user's mail client if one is configured) AND copies the
// address to the clipboard, so users without a client-of-record
// still walk away with the address pasted. A brief toast confirms
// the copy.

import { t } from "../i18n";
import { byId } from "./dom";

const CONTACT_EMAIL = "contact@karta-pamet.com";
const TOAST_MS = 1600;

export function installContactFooter(): void {
  const link = byId<HTMLAnchorElement>("contactLink");
  const toast = byId("contactToast");
  if (!link) return;
  link.addEventListener("click", () => {
    // Don't preventDefault — let the mailto fire via the browser's
    // default handler. Clipboard write is best-effort; silently
    // ignore rejections (e.g. non-secure context, denied permission).
    navigator.clipboard?.writeText(CONTACT_EMAIL).then(
      () => {
        if (toast) {
          toast.textContent = t("contact_copied") as string;
          toast.classList.add("show");
          window.setTimeout(() => toast.classList.remove("show"), TOAST_MS);
        }
      },
      () => {
        /* clipboard denied — the mailto still fires, no toast */
      },
    );
  });
}
